module.exports = __webpack_public_path__ + "img/logo-emcb-white.b5511de0.svg";